import(/* webpackMode: "eager" */ "/app/src/app/courses/[slug]/error.tsx");
